import { ReactNode } from 'react';
import { Container } from '@mui/material';

import Footer from '@/components/organisms/Footer';

type Props = {
  title?: string;
  children?: ReactNode[];
};

const RegularPage = (props: Props) => {
  return (
    <>
      <Container maxWidth={'xl'}>
        {props.title && <h1>{props.title}</h1>}
        {props.children}
      </Container>
      <Footer />
    </>
  );
};

export default RegularPage;
